import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import axios from "axios";
import { Autocomplete, TextField, createFilterOptions } from "@mui/material";
import ClipLoader from "react-spinners/ClipLoader";
import { ContainerLabel, ErrorText } from "../../AddEditPurchaseOrder.styled";
import {
  autoSearchInputStylesError,
  autoSearchInputStyles,
} from "@utils/extra-style";

const PurchaseOrderContacts = ({
  t,
  contacts,
  setContacts,
  supplierId,
  error,
}) => {
  const [availableContacts, setAvailableContacts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!supplierId) {
      setAvailableContacts([]);
      return;
    }
    setLoading(true);
  
    axios
      .get(`/allContacts?companyId=${supplierId}&typeIds=[6]`)
      .then((response) => {
        setAvailableContacts(response.data?.contacts || []);
      })
      .catch(() => {
        setAvailableContacts([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [supplierId]);

  return (
    <div>
      <ContainerLabel required>
        {t("CONTACT")}
        {loading && <ClipLoader size={13} style={{ marginLeft: "8px" }} />}
      </ContainerLabel>
      <div style={{ minHeight: "58px" }}>
        <Autocomplete
          multiple
          id="po-contacts"
          fullWidth
          options={availableContacts}
          getOptionLabel={(option) =>
            `${option.firstName || ""} ${option.lastName || ""}`.trim()
          }
          filterSelectedOptions
          disabled={loading || !supplierId}
          ChipProps={{ style: { margin: "2px 2px 0 0" } }}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder={
                !supplierId ? t("PURCHASE_ORDER_SELECT_SUPPLIER_FIRST") : ""
              }
              size="small"
              style={error ? autoSearchInputStylesError : autoSearchInputStyles}
              InputProps={{
                ...params.InputProps,
                style: { minHeight: "40px" },
              }}
            />
          )}
          value={contacts}
          onChange={(event, newValue) => {
            setContacts(newValue);
          }}
          isOptionEqualToValue={(option, value) => option?.id === value?.id}
          filterOptions={(options, params) => {
            const filtered = createFilterOptions()(options, params);
            return [...filtered];
          }}
        />
        {error && <ErrorText>{error}</ErrorText>}
      </div>
    </div>
  );
};

PurchaseOrderContacts.propTypes = {
  t: PropTypes.func.isRequired,
  contacts: PropTypes.array.isRequired,
  setContacts: PropTypes.func.isRequired,
  supplierId: PropTypes.number,
  error: PropTypes.string,
};

PurchaseOrderContacts.defaultProps = {
  supplierId: null,
  error: "",
};

export default withTranslation()(PurchaseOrderContacts);
